import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  const socialLinks = [
    {
      icon: <Instagram className="w-5 h-5" />,
      url: 'https://www.instagram.com/aura.immersion/',
      label: 'Instagram'
    },
    {
      icon: <Facebook className="w-5 h-5" />,
      url: 'https://www.facebook.com/p/Auraimmersion-61566268838163/',
      label: 'Facebook'
    },
    {
      icon: <Linkedin className="w-5 h-5" />,
      url: 'https://www.linkedin.com/company/auraimmersion/',
      label: 'LinkedIn'
    }
  ];

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#41392e]/20">
      <div className="max-w-7xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <Logo />
          </div>

          <div>
            <h3 className="text-xl mb-6 text-white font-serif">{t('footer.contact')}</h3>
            <div className="space-y-4 text-white/80">
              <a
                href="tel:+23058241702"
                className="flex items-center space-x-2 hover:text-[#c9ab81] transition-colors duration-300 cursor-pointer relative z-20"
                style={{ pointerEvents: 'auto' }}
              >
                <Phone className="w-4 h-4 text-[#c9ab81]" />
                <span>+23058241702</span>
              </a>
              <a
                href="mailto:auraimmersionilemaurice@gmail.com"
                className="flex items-center space-x-2 hover:text-[#c9ab81] transition-colors duration-300 cursor-pointer relative z-20"
                style={{ pointerEvents: 'auto' }}
              >
                <Mail className="w-4 h-4 text-[#c9ab81]" />
                <span>auraimmersionilemaurice@gmail.com</span>
              </a>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-[#c9ab81]" />
                <span>Maurice</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl mb-6 text-white font-serif">{t('footer.hours')}</h3>
            <div className="space-y-4 text-white/80">
              <p>{t('footer.schedule.weekdays')}</p>
              <p>{t('footer.schedule.saturday')}</p>
              <p>{t('footer.schedule.sunday')}</p>
            </div>

            {/* Social Icons */}
            <div className="flex items-center space-x-4 mt-8">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#c9ab81] hover:text-white transition-colors duration-300 cursor-pointer relative z-10 p-1"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      <div className="border-t border-[#41392e]/20">
        <div className="max-w-7xl mx-auto py-6 px-4 flex flex-col md:flex-row justify-between items-center text-white/60 text-sm">
          <div>{t('footer.rights')}</div>
          <div className="mt-2 md:mt-0">
            {t('footer.createdBy')} <a href="https://vyzionair.agency/" target="_blank" rel="noopener noreferrer" className="text-[#c9ab81] hover:text-white transition-colors duration-300 cursor-pointer relative z-50" style={{ pointerEvents: 'auto' }}>Vyzionair Agency</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;